import type {
  MeasureEntity,
  MeasurePropsPub,
  MeasurePropsPvt,
} from './entity/measureEntity';
import type { WagakoNurseryIApi } from '@/infra/wagakoNurseryIApi';
import type { MeasureJsonPub, MeasureJsonPvt } from '@/types/domain/measure/entities/measureEntity';

import { DomainServiceBase } from '@/domain/domainServiceBase';

/**
 * 測定アプリケーションサービス(施設)
 */
export class MeasureNurseryDomainService extends DomainServiceBase {
  private wagakoNurseryApi!: WagakoNurseryIApi;

  /**
   * Injection
   * @param wagakoNurseryApi wagakoNurseryApi
   */
  public inject(
    wagakoNurseryApi: WagakoNurseryIApi,
  ) {
    this.wagakoNurseryApi = wagakoNurseryApi;
  }

  /**
   * sendNurseryMeasure
   * @param entity entity
   */
  async sendNurseryMeasure(
    entity: MeasureEntity,
  ) {
    await this.wagakoNurseryApi.send<
      MeasurePropsPvt,
      MeasureJsonPvt,
      MeasurePropsPub,
      MeasureJsonPub
    >(entity);
  }

  /**
   * removeNurseryMeasure
   * @param entity entity
   */
  async removeNurseryMeasure(
    entity: MeasureEntity,
  ) {
    await this.wagakoNurseryApi.remove<
      MeasurePropsPvt,
      MeasureJsonPvt,
      MeasurePropsPub,
      MeasureJsonPub
    >(entity);
  }
}
